import {Conditions} from './Conditions.model'
export class MergeCondition {
    public id!: string
    public conditions!: Conditions[]
    public conditionRec!: string 
    public description!: string
    public name!: string
    public jsonQueryStringConditionRec!: string
    public conditionRecToDisplay!: string
}